module.exports = __webpack_public_path__ + "img/logo.70150309.svg";